@if (started) {
  <div class="general-loader-container">
    <div class="general-loader-pre-container">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}